import React, { useContext, useEffect } from "react";
import Footer from "../components/modules/Footer/Footer";
import globalContext from "../Context/GlobalContext";
import AboutUsMobile from "./AboutUsMobile";

export default function AboutUs() {
  const contextData = useContext(globalContext);
  useEffect(() => {
    contextData.setIsHeaderShown(true);
  }, []);
  return (
    <>
      <div className="relative hidden min-[769px]:flex w-full  flex-col items-center justify-start bg-color-primary-A ">
        <div className="w-full max-w-[1440px] h-full flex flex-col items-center justify-start ">
          <div
            dir="rtl"
            className="w-[1000px] h-[230px] flex flex-col items-center justify-center gap-y-[38px] bg-[#FFFFFF] rounded-[15px] mt-[174px]"
          >
            <div className="flex items-center justify-center gap-x-[15px]">
              <span className="font-font_primary_A font-bold text-[40px] text-color-primary-D drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)]">
                جزو بهترین ها باش با
              </span>
              <h1 className=" w-[200px] h-[75px] flex items-center justify-center font-font_primary_A font-bold text-[40px] text-color-primary-D drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)] bg-color-primary-B rounded-[10px]">
                اسکارپین
              </h1>
            </div>
            <div className="w-[712px] h-[58px] flex flex-col items-center justify-center font-font_primary_A text-[16px] text-color-primary-D">
              <p>
                کاربردی‌ترین اپلیکیشن‌ خودرو می باشد که به کمک آن می‌توانید
                تمامی اطلاعات مربوط به خودروی خود شامل تعمیرات، نگهداری، کیلومتر
                طی‌شده، مصرف سوخت و… را ذخیره کرده و مدیریتی هوشمندانه را تجربه
                کنید.
              </p>
            </div>
          </div>
          <div className="relative w-[1000px] h-[675px] flex flex-col  items-center justify-start  pt-[150px]">
            <span className="font-font_primary_A font-bold text-[36px] text-color-primary-D">
              مالکان خودرو
            </span>
            <p
              dir="rtl"
              className="w-[548px] h-[90px] font-font_primary_A font-normal text-[15px] text-color-primary-D text-justify mt-[10px]"
            >
              اپلیکیشن با سامانه اسکارپین ارتباط برقرار می‌کند. در این ارتباط
              سامانه پارامترهای «کارکرد و راه‌رفت» خودرو را دریافت و با یک
              الگوریتم محاسباتی هوشمند و مدل خودرو؛ تمام قطعات و اقلام مصرفی
              خودرو را قبل رسیدن به مراحل هشدار در اپلیکیشن آلارم و به کاربر
              نمایش می‌دهد.
            </p>
            <img
              src="../assets/images/other/line1.svg"
              className="absolute top-0 left-[60px]  "
            />
            <div className="absolute top-[117px] left-[68px] w-[50px] h-[50px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
              <img src="../assets/images/pieces/img_piece_radiator.svg" />
            </div>
            <img
              src="../assets/images/other/line2.svg"
              className="absolute top-[144px] left-[-254px]  "
            />
            <img
              src="../assets/images/other/line3.svg"
              className="absolute top-[216px] left-[138px]"
            />
            <div className="absolute top-[423px] left-[160px] w-[50px] h-[50px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
              <img src="../assets/images/pieces/img_piece_radiator.svg" />
            </div>
            <img
              src="../assets/images/other/line4.svg"
              className="absolute top-[445.5px] left-[55px]"
            />
            <div className="absolute top-[426px] left-[30px] w-[50px] h-[50px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
              <img src="../assets/images/pieces/img_piece_oil_filter.svg" />
            </div>
            <img
              src="../assets/images/other/line5.svg"
              className="absolute top-[378px] left-[-275px]"
            />
            <div className="absolute top-[506px] left-[458px] w-[50px] h-[50px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
              <img src="../assets/images/pieces/img_piece_oil_motor.svg" />
            </div>
            <img
              src="../assets/images/other/line6.svg"
              className="absolute top-[473px] left-[483px]"
            />
            <div className="absolute top-[448px] left-[725px] w-[50px] h-[50px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
              <img src="../assets/images/pieces/img_piece_filter_petrol.svg" />
            </div>
            <img
              src="../assets/images/other/line7.svg"
              className="absolute top-[250px] left-[550px]"
            />
            <div className="absolute top-[288px] left-[840px] w-[50px] h-[50px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
              <img src="../assets/images/pieces/img_piece_filter_room.svg" />
            </div>
            <img
              src="../assets/images/other/line8.svg"
              className="absolute top-[238px] left-[864px]"
            />
            <img
              src="../assets/images/other/line9.svg"
              className="absolute top-[0px] left-[864px]"
            />
            <img
              src="../assets/images/other/line10.svg"
              className="absolute top-[0px] left-[828px]"
            />
            <div className="absolute top-[150px] left-[840px] w-[50px] h-[50px] p-[8px] flex items-center justify-center bg-color-primary-B rounded-[15px] z-10">
              <img src="../assets/images/pieces/img_piece_battery.svg" />
            </div>
            <img
              src="../assets/images/other/line11.svg"
              className="absolute top-[480px] left-[750px]"
            />

            {/* <div className="absolute w-[1000px] h-[1.1px] top-[144px] left-[-1000px] bg-[#C5C8CD] -z-10"></div> */}
          </div>

          <div className="relative w-[891px] h-[277px] flex items-center justify-start rounded-[15px] bg-[#FFFFFF]  mr-[250px] ">
            <div className="w-[648px] flex flex-col items-center justify-center gap-y-[20px] pr-[40px] ">
              <h2 className="font-font_primary_A font-bold text-[40px] text-color-primary-D drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)]">
                مولتی اپلیکیشن
              </h2>
              <p
                dir="rtl"
                className="w-[523px]  font-font_primary_A text-[16px] text-color-primary-D text-justify"
              >
                نرم افزار اسکارپین یک برنامه قابل نصب بر روی تلفن همراه است که
                به واسطه آن می‌‌توانید یک مدیریت کلی بر روی خودرو خود و مسائل
                فنی آن داشته باشید. درواقع نرم ‏افزار اسکارپین یکی از کامل ترین
                و باکیفیت‏ ترین نرم‌افزارهای تخصصی در زمینه خودرو و مدیریت و
                نگهداری آن در کشور می باشد که با هدف پاسخگویی به تمام نیازهای
                دارندگان خودرو طراحی و توسعه یافته است.
              </p>
            </div>
            <img
              src="../assets/images/other/phone1.png "
              className="absolute right-[20px] w-[203px] h-[404px]"
            />
          </div>

          <div
            dir="rtl"
            className="w-[1000px] h-[1000px] flex  items-center justify-between"
          >
            <div className="flex-1 flex flex-col items-center justify-center gap-y-[84px]">
              <div className="w-[395px] h-[315px] flex items-center justify-center bg-[#FFFFFF] rounded-[15px] px-[30px]">
                <p className=" font-font_primary_A font-medium text-[12px] leading-[200%] text-color-primary-D text-justify">
                  اسکارپین از سال 1400 با هدف پایش سلامت وسائل‌نقلیه توسط جوانان
                  خلاق و توانمند در شرکت «پرشیا ایده و صنعت» طراحی و ساخته شده
                  است. اسکارپین یک سامانه پویا و هوشمند بوده که براساس الگوی
                  مصرف کاربران خودرو و با ساده سازی فرآیند تعویض قطعات و اقلام
                  مصرفی، به حفظ و نگهداری خودرو کمک می‌نماید. اسکارپین این امکان
                  را به کاربران خود می‌دهد تا در شبانه‌روز از طریق اپلیکیشن به
                  سهولت بتوانند آخرین وضعیت سلامت خودرو خود را مشاهده و جهت رفع
                  نیاز‌های خودرو خود به تعمیرگاه‌های معتبر و در دسترس مراجعه
                  نمایند. به‌منظور جلب اعتماد کاربران، تمامی نیرو‌های خدماتی
                  مستقر در تعمیرگاه‌های اسکارپین توسط این شرکت احراز و از
                  فیلترهای صلاحیت ما عبور کرده‌اند.
                </p>
              </div>

              <div className="w-[395px] h-[178px] flex items-start justify-center">
                <div className="relative w-[280px] h-[76px] flex items-center justify-center bg-color-primary-C rounded-[8px] ">
                  <span className="font-font_primary_A font-bold text-[14px] text-[#FFFFFF]">
                    مهم ترین دستاوردها در حوزه خودرو؟
                  </span>
                  <img
                    src="../assets/images/other/polyL.svg"
                    className="absolute left-[-19px] top-1/2 -translate-y-1/2"
                  />
                  <div className="absolute left-[-129px] w-[36px] h-[36px] bg-color-primary-B rounded-full"></div>
                </div>
              </div>

              <div className="w-[310px] h-[184px] flex flex-col items-center justify-between ">
                <div className="w-full h-[38.4px] flex items-center justify-start rounded-[10px] bg-[#FFFFFF] px-[20px]">
                  <span className="font-font_primary_A font-medium text-color-primary-D text-[12px] leading-[24px]">
                    حذف کارت سرویس
                  </span>
                </div>
                <div className="w-full h-[38.4px] flex items-center justify-start rounded-[10px] bg-[#FFFFFF] px-[20px]">
                  <span className="font-font_primary_A font-medium text-color-primary-D text-[12px] leading-[24px]">
                    مشتری بیشتر
                  </span>
                </div>
                <div className="w-full h-[38.4px] flex items-center justify-start rounded-[10px] bg-[#FFFFFF] px-[20px]">
                  <span className="font-font_primary_A font-medium text-color-primary-D text-[12px] leading-[24px]">
                    خرید بدون واسطه
                  </span>
                </div>
                <div className="w-full h-[38.4px] flex items-center justify-start rounded-[10px] bg-[#FFFFFF] px-[20px]">
                  <span className="font-font_primary_A font-medium text-color-primary-D text-[12px] leading-[24px]">
                    خرید اعتباری
                  </span>
                </div>
              </div>
            </div>

            <div className="w-[1px] h-full bg-[#C5C8CD] "></div>

            <div className="flex-1 flex flex-col items-center justify-center gap-y-[84px] ">
              <div className="w-[395px] h-[315px] flex items-start justify-center  rounded-[15px] px-[30px] ">
                <div className="relative w-[280px] h-[76px] flex items-center justify-center bg-color-primary-C rounded-[8px]">
                  <span className="font-font_primary_A font-bold text-[14px] text-[#FFFFFF]">
                    مهم ترین دستاوردها در حوزه خودرو؟
                  </span>
                  <img
                    src="../assets/images/other/polyR.svg"
                    className="absolute right-[-19px] top-1/2 -translate-y-1/2"
                  />
                  <div className="absolute right-[-129px] w-[36px] h-[36px] bg-color-primary-B rounded-full"></div>
                </div>
              </div>

              <div className="w-[405px] h-[178px] flex flex-col items-center justify-between">
                <div className="w-full h-[38.4px] flex items-center justify-start rounded-[10px] bg-[#FFFFFF] px-[20px]">
                  <span className="font-font_primary_A font-medium text-color-primary-D text-[12px] leading-[24px]">
                    رفع دغدغه‌های مربوط به زمان تعویض قطعات و اقلام مصرفی خودرو؛
                  </span>
                </div>
                <div className="w-full h-[38.4px] flex items-center justify-start rounded-[10px] bg-[#FFFFFF] px-[20px]">
                  <span className="font-font_primary_A font-medium text-color-primary-D text-[12px] leading-[24px]">
                    رفع دغدغه‌های مربوط به زمان تمدید معاینه‌فنی و بیمه شخص ثالث
                    خودرو؛
                  </span>
                </div>
                <div className="w-full h-[38.4px] flex items-center justify-start rounded-[10px] bg-[#FFFFFF] px-[20px]">
                  <span className="font-font_primary_A font-medium text-color-primary-D text-[12px] leading-[24px]">
                    ایجاد تحول در زمینه پایش سلامت خودرو؛
                  </span>
                </div>
                <div className="w-full h-[38.4px] flex items-center justify-start rounded-[10px] bg-[#FFFFFF] px-[20px]">
                  <span className="font-font_primary_A font-medium text-color-primary-D text-[12px] leading-[24px]">
                    بهبود ارتباط بین کاربران با تعمیرگاه‌های معتبر و توانمند؛
                  </span>
                </div>
              </div>

              <div className="w-[310px] h-[184px]  flex items-start justify-center">
                <div className="relative w-[280px] h-[76px] flex items-center justify-center bg-color-primary-C rounded-[8px]">
                  <span className="font-font_primary_A font-bold text-[14px] text-[#FFFFFF]">
                    مهم ترین دستاوردها در حوزه خودرو؟
                  </span>
                  <img
                    src="../assets/images/other/polyR.svg"
                    className="absolute right-[-19px] top-1/2 -translate-y-1/2"
                  />
                  <div className="absolute right-[-129px] w-[36px] h-[36px] bg-color-primary-B rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      <AboutUsMobile />
    </>
  );
}
